import React from 'react';
import Label from 'components/Label';
import { StyledTextField } from './styles';

function TextField({ name, label, error, labelColor, ...props }) {
  return (
    <>
      <Label htmlFor={name} style={labelColor ? { color: labelColor } : undefined}>
        {label}
      </Label>
      <StyledTextField
        id={name}
        name={name}
        rows={4}
        error={error}
        {...props}
      />
    </>
  );
}

export default TextField;
